import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateNotificationsEmailFrom(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/preferences/notifications",
    {
      invalidate: invalidateShop,
      mapVariables: (emailFrom: string) => ({
        params: { path: { shopId: shop.id } },
        body: {
          emailFrom,
        },
      }),
    },
  );
}
